import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-agris-edit-price-ins-cotiz-dialog',
  templateUrl: './agris-edit-price-ins-cotiz-dialog.component.html',
  styleUrls: ['./agris-edit-price-ins-cotiz-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisEditPriceInsCotizDialogComponent implements OnInit {


  @ViewChild('editInput') inputField: ElementRef;
  public precio = 0;
  public minimo = 0;
  public precioBase = 0;
  public margen = 0;
  public flete = 0;
  public cantidad = 1;
  public nombre = '';

  private allowedKeyCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

  constructor() { }

  ngOnInit() {
  }

  step(add) {
    this.precio = Math.max(Math.floor(this.precio + (add ? 1 : -1)), 0);
  }

  change() {
    this.margen = Number((((this.precio / this.minimo) - 1) * 100).toFixed(4));
  }

  limit(e) {
    const number = this.inputField.nativeElement.value.toString().replace(',', '.').split('.');
    if (number.length > 1 && number[1].length === 4 && this.allowedKeyCodes.indexOf(e.keyCode) !== -1) {
      e.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-edit-price-ins-cotiz-dialog/agris-edit-price-ins-cotiz-dialog.component.ts